<template>
    <NTable
      class="multi-order-list h1 dbox1" 
      :headers="headers"
      :items="list"
      :config="tableConfig"
   
    >
      <template v-slot:thead="{ thcon, thtext }">
        <tr>
          <th
            v-for="header in headers"
            v-bind="thcon(header.value)"
            :key="header.value"
          >
            <div v-if="header.value=='chk'"  class="header-name">
               <div class="minus-parent" :class="{
                 'selected': selectAllNone,
               }" @click="onCheckboxChangeAll" >
                  <div class="minus-child">
                    
                  </div>
                
               </div>
            </div>
            <div v-else-if="header.value=='exclude_for_label'" style="margin-top:10px;display:flex" class="header-name">
              <div>{{thtext(header.value)}}</div>
              <div style="margin-top:-4px">
                  <img class="arrow"
                      width="30"
                      height="30"
                    src="static/icons/question.svg"
                      alt 
                  />
              </div>
            </div>
            <div v-else class="header-name">
              {{thtext(header.value)}}
            </div>

          </th>
        </tr>
      </template>
      <template v-slot:item="{ item, tdcon }">
        <tr>
             <td v-if="!exportClick" v-bind="tdcon('chk')">
               <div class="checkbox-container">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      name="name"
                      
                      :checked="selectedProducts.has(item.product_id)"
                       @click="e => onCheckboxChange(e, 'name', item)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
            </td>
            <td v-bind="tdcon('order_date')">
                <span >{{item['order_date']}}</span>
            </td>
            
            <td v-bind="tdcon('bandcamp_order')">
                <span >{{item['order_reference']}}</span>
            </td>
   
            <td v-bind="tdcon('customer')">
                <span >{{item['order_source']}}</span>
            </td>
            <td v-bind="tdcon('city')">
                <span >{{item['deliver_city']}}</span>
            </td>
            
            
            <td v-bind="tdcon('country')">
              <span>{{item['deliver_country']}}</span>
            </td>
           
        </tr>
      
      </template>
    </NTable>
</template>

<script>

import NTable from "../../../../plugins/datatable/datatable";
import Modal from "../../../../dt-plugins/modal/modal";

import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

import { clientName } from "../../../../services/http/http-client";
import { getBaseUrl } from "../../../../services/http/http-client";
import { LABEL_URL } from "../../../../services/common-urls";

import { addRemoveSet } from '../../../../utility';

export default {
  components: {
      NTable,
      Modal,
  },
  props: {
    bandCampData: {
      type: Object,
    },
  },
  data: function () {
   return {
    tableConfig: createNTableConfig({
      headerStyle: 3,
      fullHeight:true
    }),
    selectedProducts: new Set(),
    

    exportClick: false,
   
    selectAllNone: false,
   };
  },
  mounted:async function(){
    console.log('Mounted Call');
   
    console.log("agencyRes Fetch");

    console.log("agency Fetch Done",this.proAgencyData) ;
  },
  computed: {
    headers: function () {
      return [        
        createTableHeader("chk",{text:false,mw:30}),
        createTableHeader("order_date",{}),
        createTableHeader("bandcamp_order",{}),
        createTableHeader("customer",{}),
        createTableHeader("city",{}),
        createTableHeader("country",{}),
      ];
    },


    list:function(){
      return this.bandCampData?.ordersArray||[];
    },
  },
  methods: {
    onCheckboxChangeAll:function(e){
     
     // console.log(checked);
      if ( !this.selectAllNone) {
         this.selectAllNone = true;
         //console.log("PROAGENCY DATA",thi)
         this.selectedProducts = new Set(this.proAgencyData.map(e => e.product_id));
       
      } else {
        this.selectAllNone = false;
        this.selectedProducts = new Set();
      }
    },


    onCheckboxChange: function(event, name, item) {
      const value = event.target.checked;
       this.selectedProducts = addRemoveSet(
        event.target.checked,
        this.selectedProducts,
        item.product_id
      );
      console.log("WWWW",this.selectedProducts,item);
    },
  },
};

</script>

<style lang="scss" scoped>
  .cmp-pro-agency-data-transfer{
    .minus-parent{
        padding:4px;
        background-color:white;
        border-radius:2px;
        display:flex;
        width:12px;
        justify-content:center;
        border:1px solid #000;
        cursor: pointer;

        &.selected {
          background-color:black;
        }
    }
    .minus-child{
       height:2px;
       background-color:white;
       flex:1;
       min-width:6px
    }
  }


</style>
